import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/visits/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/visits/exportExcel', data, {
    trim: true,
    download: true
  })
}
export function syncByDate (data) {
  return request.post('/business/visits/syncByDate', data)
}
// 创建
export function create (data) {
  return request.post('/business/visits/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/visits/updateById', data)
}

// 删除
export function deleteById (id) {
  return request.get(`/business/visits/delete/${id}`)
}

// 根据ID查询
export function queryById (id) {
  return request.get(`/business/visits/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/visits/delete/batch', {
    params: {
      ids
    }
  })
}
